type AssigneeNameSource =
  | { type: 'account'; email: string; fullName?: string }
  | { type: 'group'; name: string }

export const getAssigneeDisplayName = (assignee: AssigneeNameSource): string =>
  assignee.type === 'account'
    ? assignee.fullName || assignee.email
    : assignee.name
